<svg [attr.width]="arrowWidth" [attr.height]="arrowHeight" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" id="arrowIconsvg" [style]="'transform:rotate('+ rotateDeg +'deg)'">
  <path d="M8.71275 0.719999H5.95275L0.144749 6.216L5.95275 11.736H8.71275L2.90475 6.216L8.71275 0.719999Z" [attr.fill]="arrowColor"/>
</svg>
  